/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { StrNumBool } from "~/tools";
import { useQueryState } from "./useQueryState";

export function useLexicalTabsWithUrl(parameter = "tab") {
  const [tabs, setTabs] = React.useState<string[]>([]);
  const { state, set, updateQueryState } = useQueryState();

  const setActiveTab = (
    index: number,
    additionalFields?: Record<string, StrNumBool | StrNumBool[]>
  ) => {
    if (additionalFields) {
      updateQueryState({
        [parameter]: tabs[index],
        ...additionalFields,
      });
    } else {
      set(parameter)(tabs[index]);
    }
  };
  const registerTabs = (tabsToRegister: string[]) => setTabs(tabsToRegister);
  // @ts-expect-error ignored temporary after migration to TypeScript 4.9
  const activeTab = tabs.indexOf(state[parameter]);

  return {
    registerTabs,
    setActiveTab,
    activeTab: activeTab === -1 ? 0 : activeTab,
  };
}
